module.exports = __webpack_public_path__ + "img/6.d29cd706.jpeg";